import React from 'react';
import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';
import { ThemeProvider } from '@mui/material';
import { AppRouter } from './router/AppRouter';
import { commonMUITheme } from './styles/CommonStyles';
//ClassNameGenerator.configure((componentName) =>`css-xyz-${componentName}`);
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { firebaseConfig } from './Firebase/FirebaseConfig';
import WebViewModal from './components/Modals/WebViewModal';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const App = () => {
  return (
    <React.StrictMode>
      <ThemeProvider theme={commonMUITheme}>
        <WebViewModal />
        <AppRouter />
      </ThemeProvider>
    </React.StrictMode>
  );
}

export default App;
